<div class="cnt-self-video">
  <video #videoSelf playsinline autoplay></video>
</div>
